import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { toGreekCaps } from '~/lib/i18n/toGreekCaps';

interface RailCardProps {
	/** Mixed-case label; rendered uppercased via toGreekCaps. */
	label: string;
	icon?: LucideIcon;
	children: ReactNode;
}

/** Right-rail card with an uppercase label, optional right-aligned icon, and content. */
export function RailCard({ label, icon: Icon, children }: RailCardProps) {
	return (
		<div className="rounded-lg border border-border bg-surface p-4">
			<div className="mb-3 flex items-center justify-between">
				<span className="text-xs font-semibold tracking-[0.06em] text-foreground-subtle">{toGreekCaps(label)}</span>
				{Icon && <Icon size={14} className="text-foreground-subtle" />}
			</div>
			{children}
		</div>
	);
}
